import { Injectable } from '@angular/core';

import { TranslateService } from '../../../api/translate.service';
import { ColDef } from 'ag-grid-community';
import { 
  fieldAccountCodeCol, 
  fieldAddressLine1Col, 
  fieldAddressLine2Col, 
  fieldAmountCol, 
  fieldApprovedByCol, 
  fieldBuildingNameCol, 
  fieldCountryCol, 
  fieldCreatedByCol, 
  fieldCurrencyCol, 
  fieldCustomerNameCol, 
  fieldDateCol, 
  fieldDisbursementIncludedInFeesCol, 
  fieldDistrictCol, 
  fieldExpenseTypeCol, 
  fieldIdCol, 
  fieldInvoiceIdCol, 
  fieldInvoiceTypeCol, 
  fieldLocalityCol, 
  fieldMiqIdCol, 
  fieldOppNumberCol, 
  fieldOpportunityCol, 
  fieldOpportunityInstallmentCol, 
  fieldOpportunitySourceCol, 
  fieldPostcodeCol, 
  fieldPrimaryEmployeeFunctionalUnitCol, 
  fieldPrimaryEmployeeFunctionalUnitIdCol, 
  fieldPrimaryEmployeeIdCol, 
  fieldPrimaryEmployeeManagingOfficeCol, 
  fieldPrimaryEmployeeManagingOfficeIdCol, 
  fieldPrimaryEmployeeNameCol, 
  fieldProjectCodeCol, 
  fieldProjectDescriptionCol, 
  fieldRegionCol, 
  fieldRepresentedPartyCol, 
  fieldSubmittedByCol, 
  fieldSuburbCol, 
  fieldTeamCol, 
  fieldTransactionTypeCol 
} from '../../../utils/ag-grid/column-defs';

@Injectable({
  providedIn: 'root',
})
export class DisbursementsService {
  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any; left: any; right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_PARTY'),
        key: 'repped_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
        key: 'producer_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
        key: 'producer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT'),
        key: 'producer_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'),
        key: 'producer_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE'),
        key: 'producer_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE_DESCRIPTION'),
        key: 'producer_managing_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DISBURSEMENT_INCL_FEES'),
        key: 'disbursement_included_in_fees',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('EXPENSE_TYPE'),
        key: 'expense_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ACCOUNT'),
        key: 'account',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DISBURSEMENT_BROKER_EMPLOYEE_ID'),
        key: 'disbursement_broker_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DISBURSEMENT_BROKER_EMPLOYEE_NAME'),
        key: 'disbursement_broker_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROJECT_CODE'),
        key: 'expense_project_code',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROJECT_DESCR'),
        key: 'expense_project_description',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REIMBURSEMENT_AMOUNT'),
        key: 'expense_reimbursement_amount',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DISBURSEMENT_ALLOC_AMT'),
        key: 'disbursement_amount',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },      
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },      
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },      
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },     
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },       
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      }, 
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },           
      {
        ...fieldRepresentedPartyCol,
        field: 'repped_customer_name',
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
      },   
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },      
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },      
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },      
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },        
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },           
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },         
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },      
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },   
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },       
      {
        ...fieldPrimaryEmployeeIdCol,
        field: 'producer_employee_id',
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
      },      
      {
        ...fieldPrimaryEmployeeNameCol,
        field: 'producer_name',
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
      },  
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        field: 'producer_functional_unit_id',
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT'),
      },      
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        field: 'producer_functional_unit',
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'),
      },      
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        field: 'producer_managing_office_id',
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        field: 'producer_managing_office',
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE_DESCRIPTION'),
      }, 
      {
        ...fieldDisbursementIncludedInFeesCol,
        headerName: this.translateService.getTranslation('DISBURSEMENT_INCL_FEES'),
      },
      {
        ...fieldExpenseTypeCol,
        headerName: this.translateService.getTranslation('EXPENSE_TYPE'),
      },
      {
        ...fieldAccountCodeCol,
        field: 'account',
        headerName: this.translateService.getTranslation('ACCOUNT'),
      },
      {
        ...fieldPrimaryEmployeeIdCol,
        field: 'disbursement_broker_employee_id',
        headerName: this.translateService.getTranslation('DISBURSEMENT_BROKER_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        field: 'disbursement_broker_employee_name',
        headerName: this.translateService.getTranslation('DISBURSEMENT_BROKER_EMPLOYEE_NAME'),
      },
      {
        ...fieldProjectCodeCol,
        field: 'expense_project_code',
        headerName: this.translateService.getTranslation('PROJECT_CODE'),
      },
      {
        ...fieldProjectDescriptionCol,
        field: 'expense_project_description',
        headerName: this.translateService.getTranslation('PROJECT_DESCR'),
      },
      {
        ...fieldAmountCol,
        field: 'expense_reimbursement_amount',
        headerName: this.translateService.getTranslation('REIMBURSEMENT_AMOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'disbursement_amount',
        headerName: this.translateService.getTranslation('DISBURSEMENT_ALLOC_AMT'),
      },
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },      
    ];
  }
}
